export enum AbilityAction {
    MANAGE = 'manage',
    CREATE = 'create',
    // LIST = 'list',
    READ = 'read',
    UPDATE = 'update',
    DESTROY = 'destroy',
}
